//修改地图省份重叠问题

export default function() {
  var chinaEchartsObj = window.echarts.getMap('china')
  var geoJSONChina = chinaEchartsObj.geoJson
  var allDefProvince = geoJSONChina.features
  for (var i = 0, len = allDefProvince.length; i < len; i++) {
    var sglProvinceProperties = allDefProvince[i].properties
    var sglProvinceName = sglProvinceProperties.name
    switch (sglProvinceName) {
      case '新疆':
        sglProvinceProperties.cp[0] = 87.617733
        sglProvinceProperties.cp[1] = 41.792818
        break
      case '山西':
        sglProvinceProperties.cp[0] = 110.95
        sglProvinceProperties.cp[1] = 37.95
        break
      case '青海': //def:101.778916,36.623178
        sglProvinceProperties.cp[0] = 97.617733
        sglProvinceProperties.cp[1] = 36.623178
        break
      case '江苏': //def:118.767413,32.041544
        sglProvinceProperties.cp[0] = 119.767413
        sglProvinceProperties.cp[1] = 33.041544
        break
      case '浙江': //def:118.767413,32.041544
        sglProvinceProperties.cp[0] = 119.767413
        sglProvinceProperties.cp[1] = 29.041544
        break
    }
  }
  window.echarts.registerMap('china', geoJSONChina, {})
}
